module.exports = __webpack_public_path__ + "static/media/brand2.ea5d3c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/brand2.png
// module id = 531
// module chunks = 0